import { Routes } from '@angular/router';

export const CARTA_AVARIAS_ROUTES: Routes = [
  {
    path: 'carta-enviada',
    loadComponent: async () =>
      (await import('./pages/carta-enviada/carta-enviada.page')).CartaEnviadaPage,
  },
  {
    path: ':api',
    loadComponent: async () =>
      (await import('./carta-avarias.domain')).CartaAvariasDomain,
    canActivateChild: [],
    children: [
      {
        path: '',
        loadComponent: async () =>
          (await import('./pages/carta/carta.page')).CartaPage,
        canActivate: [],
      },
    ],
  },
];
